import { Autocomplete, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';

CategorySelect.propTypes = {
  setSelectedCategory: PropTypes.func,
  selectedCategory: PropTypes.string,
  facility: PropTypes.object,
  categoryOptions: PropTypes.array
};
export default function CategorySelect({  selectedCategory, setSelectedCategory, categoryOptions }) {


  return (
    <>
      <DialogTitle
        sx={{
          textAlign: 'center',
          color: 'rgba(112, 112, 112, 0.5)',
        }}
      >
        Rental Type
      </DialogTitle>
      {categoryOptions?.length !== 0 && <DialogContentText sx={{ fontWeight: 'bold' }}>Category Name</DialogContentText>}
      {categoryOptions?.length !== 0 ? <Autocomplete
        sx={{
          width: '100%',
          mt: 1,
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiFormLabel-root ': 'none',
        }}
        type="new-password"
        options={categoryOptions}
        autoHighlight
        getOptionLabel={(option) => option.label}
        renderOption={(props, option) => (
          <li {...props}>
            {<Iconify icon={option.icon} />}
            {option.label}
          </li>
        )}
        value={selectedCategory?.label}
        onChange={(event, option) => {
          setSelectedCategory(option?.label || '');
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            variant="outlined"
            inputProps={{
              ...params.inputProps,
            }}
            autoComplete="off"
          />
        )}
      /> : <Typography variant="paragraph" sx={{ fontSize: '15px', mr: 'auto', ml: 'auto', textAlign: 'center', display:'flex', alignItems: 'center', mt: 2, justifyContent: 'center' }}>
            This facility does not have any items associated with its vendors.
          </Typography>
      }</>
  );
}
